import { useEffect, useState } from "react";
import * as candidatesService from "../../src/services/candidates-service"
import { CandidateItemProps } from "../components/candidateItem/model";
import { CandidateDetails } from "../pages/candidate/model";
import { ApplicationCandidateProps } from "../components/applicationCandidate/model";

export const useGetAllCandidates = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [candidates, setCandidates] = useState<Array<CandidateItemProps>>([]);

    useEffect(() => {
        candidatesService.getAllCandidates().then((candidates: Array<CandidateItemProps>) => {
            setCandidates(candidates);
            setIsLoading(false);
        })
    }, []);

    return { candidates, isLoading, setCandidates };
}

export const useGetCandidateById = (id: string) => {
    const [isLoading, setIsLoading] = useState(true);
    const [candidateData, setCandidateData] = useState<CandidateDetails>();

    useEffect(() => {
        candidatesService.getCandidateById(id).then((candidate: CandidateDetails) => {
            setCandidateData(candidate);
            setIsLoading(false);
        })
    }, [])

    return { candidateData, isLoading }
}

export const useGetCandidateByApplicationId = (id: string) => {
    const [isLoading, setIsLoading] = useState(true);
    const [candidateData, setCandidateData] = useState<CandidateDetails>();

    useEffect(() => {
        candidatesService.getCandidateByApplicationId(id).then((candidate: CandidateDetails) => {
            setCandidateData(candidate);
            setIsLoading(false);
        })
    }, [])

    return { candidateData, isLoading }
}

export const useGetFavouriteCandidates = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [candidates, setCandidates] = useState<Array<CandidateItemProps>>([]);

    useEffect(() => {
        candidatesService.getFavouriteCandidates().then((candidates: Array<CandidateItemProps>) => {
            setCandidates(candidates);
            setIsLoading(false);
        })
    }, [])

    return { candidates, isLoading };
}

export const useUpdateFavouriteCandidates = () => {
    const [isLoading, setIsLoading] = useState(false);

    const updateFavouiteCandidates = (id: string) => {
        setIsLoading(true);

        return candidatesService.updateFavouriteCandidates(id).then((data: any) => {
            setIsLoading(false);
        });
    };

    return { updateFavouitesCandidates: updateFavouiteCandidates, isLoading };
}

export const useGetHistoryCandidates = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [candidates, setCandidates] = useState<Array<ApplicationCandidateProps>>([]);

    useEffect(() => {
        candidatesService.getHistoryCandidates().then((candidates: Array<ApplicationCandidateProps>) => {
            setCandidates(candidates);
            setIsLoading(false);
        })
    }, [])

    return { candidates, isLoading };
}


export const useGetActiveCandidates = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [candidates, setCandidates] = useState<Array<ApplicationCandidateProps>>([]);

    useEffect(() => {
        candidatesService.getActiveCandidates().then((candidates: Array<ApplicationCandidateProps>) => {
            setCandidates(candidates);
            setIsLoading(false);
        })
    }, [])

    return { candidates, isLoading };
}